import { useTranslation } from 'react-i18next'

import { useHadFullSurvey } from 'features/reportsExperience/hooks/useHadFullSurvey'

import { useGetCategoriesQuery } from 'store/category/categoryApi'

import { useGetSurveyWindowArchiveComparisonQuery } from 'store/surveyWindow/surveyWindowApi'

export const useMenuGroupExperience = () => {
  const { t } = useTranslation()

  const { data: archive, isSuccess: isArchiveSuccess } =
    useGetSurveyWindowArchiveComparisonQuery()

  const { data: categories, isSuccess: isSuccessCategories } =
    useGetCategoriesQuery()

  const { hadFullSurvey } = useHadFullSurvey(archive)

  const EXPERIENCE_CODE = 'experience'

  if (isArchiveSuccess) {
    return {
      sidebarItems: {
        code: EXPERIENCE_CODE,
        enabled: hadFullSurvey,
        text: t(`${EXPERIENCE_CODE}.title`),
        url: `/${EXPERIENCE_CODE}`,
        items:
          isSuccessCategories && categories.length > 0
            ? categories.map(item => ({
                code: item,
                text: t(`category.${item}`),
                url: `/${EXPERIENCE_CODE}/${item}`,
                enabled: true,
              }))
            : undefined,
      },
    }
  }
  return { sidebarItems: undefined }
}
